/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free PPI calculator. Find a screen's pixel density from its resolution and diagonal size, plus the dot pitch in millimetres.`)
};

const es_ppi_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de PPI gratuita. Averigua la densidad de píxeles de una pantalla a partir de su resolución y tamaño diagonal, además del paso de píxel en milímetros.`)
};

const de_ppi_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser PPI-Rechner. Ermittle die Pixeldichte eines Bildschirms aus Auflösung und Diagonale, inklusive Pixelabstand in Millimetern.`)
};

const nl_ppi_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis PPI calculator. Bereken de pixeldichtheid van een scherm op basis van resolutie en diagonale grootte, plus de dot pitch in millimeters.`)
};

const fr_ppi_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur PPP gratuit. Trouvez la densité de pixels d'un écran à partir de sa résolution et de sa taille diagonale, ainsi que le pas de masque en millimètres.`)
};

const it_ppi_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore PPI gratuito. Trova la densità di pixel di uno schermo dalla risoluzione e dalla diagonale, più il dot pitch in millimetri.`)
};

const pt_br2_ppi_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de PPI gratuita. Descubra a densidade de pixels de uma tela a partir da resolução e do tamanho diagonal, além do dot pitch em milímetros.`)
};

const pt_ppi_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de PPI gratuita. Determine a densidade de pixels de um ecrã a partir da sua resolução e tamanho diagonal, além do pitch de píxel em milímetros.`)
};

const ja_ppi_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のPPI計算機。解像度と対角サイズから画面のピクセル密度と、ミリメートル単位のドットピッチを算出します。`)
};

const zh_ppi_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 PPI 计算器。根据屏幕的分辨率和对角线尺寸计算像素密度，以及以毫米为单位的点距。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_meta_description", locale)
	if (locale === "en") return en_ppi_meta_description(inputs)
	if (locale === "es") return es_ppi_meta_description(inputs)
	if (locale === "de") return de_ppi_meta_description(inputs)
	if (locale === "nl") return nl_ppi_meta_description(inputs)
	if (locale === "fr") return fr_ppi_meta_description(inputs)
	if (locale === "it") return it_ppi_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_meta_description(inputs)
	if (locale === "pt") return pt_ppi_meta_description(inputs)
	if (locale === "ja") return ja_ppi_meta_description(inputs)
	return zh_ppi_meta_description(inputs)
};